<div class="lp-map" style="width: 100%; height: 100%">
  @let _map = map();
  @switch (_map.dataType) {
    @case ('CanvasMap') {
      <lp-canvas-map [map]="_map" style="display: block; width: 100%; height: 100%" />
    }
    @case ('ClassicMap') {
      <lp-classic-map [map]="_map" style="display: block; width: 100%; height: 100%" />
    }
  }
</div>
